import React, { useCallback } from 'react';
import styled from 'styled-components';

import { RowContainer, HeaderText } from '../atoms';
import { HeaderList } from '../../entity/type';

const HeaderContainer = styled(RowContainer)`
  width: 100%;
  height: 56px;
  position: sticky;
  top: 0;

  padding: 10px 20px;

  justify-content: center;
  align-items: center;

  background-color: rgb(0, 0, 0);
  backdrop-filter: blur(8px);
  z-index: 9999;
`;

const HeaderTextContainer = styled(RowContainer)`
  width: 100%;
  position: relative;

  justify-content: space-between;
  @media (min-width: 800px) {
    max-width: 1024px;
  }
`;

type HeaderEventAreaProps = {
  index: number;
};

const HeaderEventArea = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 25%;
  height: 28px;

  border-radius: 12px;

  background: white;

  transform: translateX(
    ${(props: HeaderEventAreaProps) => `${props.index * 100}%`}
  );
  transition-property: transform;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
`;

interface HeaderProps {
  currentIndex: number;
  onClickHeaderItem: (index: number) => void;
  headerList: HeaderList[] | null;
}

function Header({ currentIndex, onClickHeaderItem, headerList }: HeaderProps) {
  const HeaderTextComponent = useCallback(
    (v, i) => (
      <HeaderText
        onClick={() => onClickHeaderItem(i)}
        isSelected={i === currentIndex}
        color={v.color}
        key={v.name}
      >
        {v.name}
      </HeaderText>
    ),
    [currentIndex, onClickHeaderItem]
  );

  return (
    <HeaderContainer>
      <HeaderTextContainer>
        {headerList && headerList.map(HeaderTextComponent)}
        <HeaderEventArea index={currentIndex} />
      </HeaderTextContainer>
    </HeaderContainer>
  );
}

export default Header;
